export default __webpack_public_path__ + "static/font-7a747dd61d5f25261033281abc5db05b.ttf";